export default {
    common: {
        email: 'Email',
        LoginBtn: 'Se Connecter',
        SignUpBtn: `S'inscrire`,
        SubmitBtn: 'Confirmer',
        ExitBtn: 'Quitter',
        LogoutBtn: 'Déconnexion'
    },
    login: {},
    login2FA: {
        pleaseCheckEmail: 'Veuillez vérifier votre email pour le code de vérification.',
        VerificationCode: 'Code de vérification'
    },
    header: {
        OrderHistory: 'Historique des commandes',
        MYACCOUNT: 'MON COMPTE',
        WelcomeBack: 'Bienvenue'
    },
    detail: {
        TotalOrders: 'Total des commandes',
        TotalProducts: 'Total des produits',
        WonderlandPoints: 'Points Wonderland',
        APMCredits: 'APM Crédit',
        ExpireOn: `Expiration`,
        NoAPMCredits: 'Aucun crédit APM',
        CreditsLoading: 'Chargement des crédits',
        Orders: 'Commande',
        Online: 'En ligne',
        Boutique: 'Boutique',
        Total: 'Total',
        Delivered: 'Livrée',
        NoData: 'Aucune Donnée',
        Status: 'Statut',
        item: 'article',
        items: 'articles'
    },
    panel: {},
    entry: {
        Client: 'Client',
        OrderDate: 'Date de la Commande',
        DeliverDate: 'Date de livraison',
        Description: 'Description',
        Total: 'Total'
    },
    board: {
        Order: 'COMMANDE',
        Date: 'DATE',
        Total: 'TOTAL'
    },
    order: {
        OrderID: 'ID Commande',
        PurchasePlace: 'Lieu',
        PurchaseDate: 'Date de la Commande',
        TotalPrice: 'Prix Total',
    },
    product: {
        Name: 'Nom',
        SKU: 'SKU',
        Size: 'Taille',
        Quantity: 'Quantité',
        Price: 'Prix',
        WarrantyUntil: `Garantie jusqu'au`,
    },
    ordersLayout: {
            pageTitleOrders: "Commandes",
            wonderlandPointsBrand: "WONDERLAND POINTS",
            navHomepage: "Accueil",
            navProfile: "Profil",
            navOrders: "Commandes",
            navWonderland: "Wonderland",
            navWishlist: "Liste de souhaits",
            navContactUs: "Nous contacter",
            navExchangeReturn: "Échange et retour",
            footerExchangePolicy: "Politique d’échange et de retour",
            footerShipping: "Livraison",
            footerPrivacy: "Politique de confidentialité",
            footerTerms: "Conditions d’utilisation",
            footerRegion: "France",
            menuTrackOrder: "Suivre la commande",
            menuViewDetails: "Voir les détails",
            back: "Retour",
            orderNumberHeading: "Numéro de commande {{id}}",
            itemsCount_one: "{{count}} article",
            itemsCount_other: "{{count}} articles",
            emptyOrders: "Aucune commande",
            invoiceSoon: "Bientôt disponible",
            storeAddressPending: "Adresse à venir",
            skuPrefix: "SKU",
            statusLabel: "Statut",
            productNameFallback: "Produit",
            tabOnline: "SITE",
            tabOffline: "BOUTIQUE",
            learnMore: "EN SAVOIR PLUS",
            redeemInStore: "UTILISER EN BOUTIQUE",
            dateLabel: "Date",
            itemSingular: "Article",
            statusConfirmed: "Confirmé le",
            purchaseDateLabel: "Date d'achat :",
            monthJan: "Janv.",
            monthFeb: "Févr.",
            monthMar: "Mars",
            monthApr: "Avr.",
            monthMay: "Mai",
            monthJun: "Juin",
            monthJul: "Juil.",
            monthAug: "Août",
            monthSep: "Sept.",
            monthOct: "Oct.",
            monthNov: "Nov.",
            monthDec: "Déc.",
            storeLabel: "Boutique",
            downloadInvoice: "Télécharger la facture",
            warrantyExpires: "Garantie expire le",
            sizeLabel: "Taille",
            subtotalLabel: "Sous-total",
            totalLabel: "Total",
        },
}


// WEBPACK FOOTER //
// ./src/locales/fr/index.js